<template>
  <section class="[ max-w-5xl mx-auto ]">
    <router-view />
  </section>
</template>

<script setup lang="ts">
definePage({
  meta: {
    icon: "user-group",
    title: "Customers",
    scope: "Customer.Read",
  },
});
</script>
